module.exports = __webpack_public_path__ + "fonts/AnyConv.com__SourceSansPro-BoldItalic.390d9bc4.woff";